<ion-header>
  <ion-toolbar>
    <ion-title>Notificación</ion-title>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" *ngIf="notification">
  <h2 [innerHTML]="notification.body"></h2>
  <p>{{notification.created_at | time}}</p>
  <ion-img
    [src]="notification.image"
    *ngIf="notification.image"
    (click)="viewImage(notification.image, '', '')"
  ></ion-img>
</ion-content>
